/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


document.querySelectorAll('.lg-accordion').forEach(accordion => {
  accordion.addEventListener('toggle', function() {
    const content = accordion.querySelector('.lg-accordion__body');
    if (accordion.open) {
      content.style.maxHeight = content.scrollHeight + "px"; 
    } else {
      content.style.maxHeight = "0";
    }
  });

  console.log('lg-content')
});

document.addEventListener('DOMContentLoaded', function () {
  scrollSlider();
});

function scrollSlider () {
  document.querySelectorAll('.scroll-slider').forEach(slider => {
      // Set the number of dots
      const numberOfDots = 4;

      // Create the dot container
      let scrollContainer = slider.querySelector('.scroll');
      let prevButton = slider.querySelector('.scroll_prev');
      let nextButton = slider.querySelector('.scroll_next');
      let dotsContainer = slider.querySelector('.dots-container');

      if (!prevButton && !nextButton) {
          slider.innerHTML += `<div class="slider-button scroll_prev hide"></div><div class="slider-button scroll_next"></div>`
      }

      if (!dotsContainer) {
          slider.innerHTML += `<div class="dots-container"></div>`;
      }

      scrollContainer = slider.querySelector('.scroll');
      prevButton = slider.querySelector('.scroll_prev');
      nextButton = slider.querySelector('.scroll_next');
      dotsContainer = slider.querySelector('.dots-container');

      if (scrollContainer && scrollContainer.children.length <= 0) {
          slider.style.display = "none";
      }

      // Determine scroll amount based on the number of dots
      const scrollAmount = scrollContainer.scrollWidth / numberOfDots;

      // Create dots based on the defined number of dots
      if (dotsContainer.children.length <= 0) {
          for (let i = 0; i < numberOfDots; i++) {
              const dot = document.createElement('div');
              dot.classList.add('dot');
              dot.dataset.index = i;  // Store the index in a data attribute
              dotsContainer.appendChild(dot);
          }
      }

      // Set initial active dot
      updateActiveDot(scrollContainer, dotsContainer);

      // Listen for scroll changes to update buttons and dots
      scrollContainer.addEventListener('scroll', () => {
          updateButtonsVisibility(scrollContainer, prevButton, nextButton);
          updateActiveDot(scrollContainer, dotsContainer);
      });

      // Activate dot on click
      dotsContainer.addEventListener('click', (e) => {
          if (e.target.classList.contains('dot')) {
              const index = parseInt(e.target.dataset.index, 10);
              const targetScrollLeft = index * scrollAmount; // Calculate the target scroll position based on index
              
              smoothScrollTo(scrollContainer, targetScrollLeft, 500, () => {
                  updateButtonsVisibility(scrollContainer, prevButton, nextButton);
                  updateActiveDot(scrollContainer, dotsContainer);
              });
          }
      });
  });

  document.addEventListener('click', function (e) {
      if (e.target.classList.contains('slider-button')) {
          const slider = e.target.closest('.scroll-slider');
          const scrollContainer = slider?.querySelector('.scroll');
          const prevButton = slider?.querySelector('.scroll_prev');
          const nextButton = slider?.querySelector('.scroll_next');

          if (scrollContainer) {
              const scrollAmount = scrollContainer.scrollWidth / 4; // Adjust based on the number of dots
              const direction = e.target.classList.contains('scroll_prev') ? -scrollAmount : scrollAmount;

              smoothScrollTo(scrollContainer, scrollContainer.scrollLeft + direction, 500, () => {
                  updateButtonsVisibility(scrollContainer, prevButton, nextButton);
                  updateActiveDot(scrollContainer, slider.querySelector('.dots-container'));
              });
          }
      }
  });
}

/**
* Smooth scrolling function
*/
function smoothScrollTo(element, target, duration, callback) {
  const start = element.scrollLeft;
  const change = target - start;
  const startTime = performance.now();

  function animateScroll(currentTime) {
      const elapsedTime = currentTime - startTime;
      const progress = Math.min(elapsedTime / duration, 1);
      const easeInOutQuad = progress < 0.5 
          ? 2 * progress * progress 
          : -1 + (4 - 2 * progress) * progress;

      element.scrollLeft = start + change * easeInOutQuad;

      if (elapsedTime < duration) {
          requestAnimationFrame(animateScroll);
      } else if (callback) {
          callback(); // Ensure buttons update after scrolling
      }
  }

  requestAnimationFrame(animateScroll);
}

/**
* Hide or show slider buttons based on scroll position
*/
function updateButtonsVisibility(scrollContainer, prevButton, nextButton) {
  const maxScrollLeft = scrollContainer.scrollWidth - scrollContainer.clientWidth;

  prevButton.classList.toggle('hide', scrollContainer.scrollLeft <= 0);
  nextButton.classList.toggle('hide', scrollContainer.scrollLeft >= maxScrollLeft);
}

/**
* Update the active dot based on the scroll position
*/
function updateActiveDot(scrollContainer, dotsContainer) {
  if (!scrollContainer.children.length) return;
  const slideWidth = scrollContainer.scrollWidth / dotsContainer.children.length; // Calculate based on number of dots
  const index = Math.ceil(scrollContainer.scrollLeft / slideWidth);

  dotsContainer.querySelectorAll('.dot').forEach((dot, i) => {
      dot.classList.toggle('active', i === index);
  });
}

// ^^ Keep your scripts inside this IIFE function call to 
// avoid leaking your variables into the global scope.


document.body.addEventListener('click', function(e) {
    if (e.target.classList.contains('rebuy-cart__flyout-close')) {
        document.getElementById('cart-drawer').querySelector('.drawer__underlay').click();
    } else if (e.target.classList.contains('rebuy-cart__background')) {
        document.getElementById('cart-drawer').querySelector('.drawer__underlay').click();
    }
})

let hTime1 = setInterval(() => {
    const klavyio = document.querySelector('.klaviyo-bis-trigger');

    if(klavyio) {
        clearInterval(hTime1);
        const ATCContainer = document.querySelector('.product-form')?.querySelector('.product__submit__buttons');
        
        if(ATCContainer) {
            ATCContainer.append(klavyio);
        }

        // If a variant is already selected, force-update BIS state once button exists
        const variantInput = document.querySelector('input[name="id"]');
        if (variantInput && variantInput.value) {
            document.dispatchEvent(
                new CustomEvent('theme:variant:change', {
                    detail: { variant: { id: Number(variantInput.value) } },
                    bubbles: true,
                })
            );
        }
    }
}, 100);

// Handle BIS "Unavailable" state based on variant metafield
(function() {
    const hideBisData = document.querySelector('[data-variant-hide-bis-metafield]')?.textContent;
    if (!hideBisData) return;

    const variantsHideBis = JSON.parse(hideBisData);
    let originalBisLabel = null;
    let clickGuardBound = false;
    let lastVariantId = null;
    let bisObserver = null;
    
    // Function to check and update BIS button state based on variant
    function updateBisButtonState(variantId) {
        if (!variantId) return;
        lastVariantId = variantId;
        
        const bisButton = document.querySelector('.klaviyo-bis-trigger');
        if (!bisButton) {
            // BIS button often gets injected after the first option selection.
            // Watch for it briefly, then apply the latest variant state once it exists.
            if (!bisObserver) {
                bisObserver = new MutationObserver(() => {
                    const btn = document.querySelector('.klaviyo-bis-trigger');
                    if (!btn) return;
                    try {
                        updateBisButtonState(lastVariantId);
                    } finally {
                        bisObserver.disconnect();
                        bisObserver = null;
                    }
                });
                bisObserver.observe(document.documentElement, { childList: true, subtree: true });
            }
            return;
        }
        
        if (originalBisLabel === null) {
            originalBisLabel = (bisButton.textContent || '').trim() || 'Notify Me When Available';
        }

        let shouldBeUnavailable = false;
        variantsHideBis.forEach((variantData) => {
            if (Number(variantData.variant_id) === Number(variantId)) {
                // Check if hide_bis is true (can be string "true" or boolean true)
                shouldBeUnavailable = variantData.hide_bis === 'true' || variantData.hide_bis === true;
            }
        });

        // Ensure we have a single click-guard handler (prevents Klaviyo modal opening when "Unavailable")
        if (!clickGuardBound) {
            clickGuardBound = true;
            document.addEventListener(
                'click',
                function(e) {
                    const target = e.target && (e.target.closest ? e.target.closest('.klaviyo-bis-trigger') : null);
                    if (!target) return;
                    if (target.classList.contains('lg-bis-unavailable')) {
                        e.preventDefault();
                        e.stopPropagation();
                    }
                },
                true
            );
        }

        // When metafield is true: show disabled "Unavailable" button instead of BIS trigger
        if (shouldBeUnavailable) {
            bisButton.textContent = 'Unavailable';
            bisButton.classList.add('lg-bis-unavailable');
            bisButton.setAttribute('aria-disabled', 'true');
            bisButton.setAttribute('tabindex', '-1');
            // Inline pointer-events as an extra guard (CSS class also styles it)
            bisButton.style.pointerEvents = 'none';
            // Ensure opacity is updated even if CSS selector context changes
            bisButton.style.opacity = '0.4';
        } else { 
            // Restore normal BIS behavior and let existing CSS control visibility
            bisButton.textContent = originalBisLabel;
            bisButton.classList.remove('lg-bis-unavailable');
            bisButton.removeAttribute('aria-disabled');
            bisButton.removeAttribute('tabindex');
            bisButton.style.pointerEvents = '';
            bisButton.style.opacity = '';
        }
    }

    // Listen for variant changes
    document.addEventListener('theme:variant:change', function(e) {
        if (e.detail && e.detail.variant && e.detail.variant.id) {
            updateBisButtonState(e.detail.variant.id);
        }
    });

    // Also listen for direct variant input changes (fallback)
    function setupVariantListener() {
        const variantInput = document.querySelector('input[name="id"]');
        if (variantInput) {
            variantInput.addEventListener('change', function() {
                if (this.value) {
                    updateBisButtonState(this.value);
                }
            });
            
            // Check initial variant on page load
            if (variantInput.value) {
                updateBisButtonState(variantInput.value);
            }
        }
    }

    // Initialize on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            setupVariantListener();
            // Wait a bit for Klaviyo to initialize the button, then check initial state
            setTimeout(function() {
                const variantInput = document.querySelector('input[name="id"]');
                if (variantInput && variantInput.value) {
                    updateBisButtonState(variantInput.value);
                }
            }, 500);
        });
    } else {
        setupVariantListener();
        // If DOM is already loaded, wait a bit for Klaviyo button
        setTimeout(function() {
            const variantInput = document.querySelector('input[name="id"]');
            if (variantInput && variantInput.value) {
                updateBisButtonState(variantInput.value);
            }
        }, 500);
    }
})();

// Initialize dropdown variant picker
function initializeDropdownVariantPickers(container) {
    const targetContainer = container || document;
    
    targetContainer.querySelectorAll('.dropdown-variant__picker').forEach(picker => {
        // Skip if already initialized
        if (picker.hasAttribute('data-dropdown-initialized')) return;
        picker.setAttribute('data-dropdown-initialized', 'true');

        const option_title = picker.querySelector('.dropdown_toggle');
        
        // Get sold out text from the closest wrapper with data attribute
        let soldOutTextWrapper = picker.closest('[data-sold-out-text-wrapper]');
        let soldOutText = soldOutTextWrapper ? soldOutTextWrapper.getAttribute('data-sold-out-text') : null;

        if (!soldOutText) {
            soldOutText = "Sold out";
        }

        picker.querySelectorAll('input').forEach(input => {
            input.addEventListener('click', function (e) {
                if (option_title) {
                    const toggleButton = option_title;
                    
                    if (input.classList.contains('sold-out')) {
                        toggleButton.querySelector('.option_title').innerHTML = `${picker.dataset.optionName} ${input.value} - ${soldOutText}`;
                        toggleButton.classList.add('sold-out-selected');
                    } else if(input.classList.contains('unavailable')) {
                        toggleButton.querySelector('.option_title').innerHTML = `${picker.dataset.optionName} ${input.value} - Unavailable`;
                        toggleButton.classList.add('sold-out-selected');
                    } else {
                        toggleButton.querySelector('.option_title').innerHTML = `${picker.dataset.optionName} ${input.value}`;
                        toggleButton.classList.remove('sold-out-selected');
                    }

                    toggleButton.setAttribute('data-btn-variant-id', input.dataset.valueVariantId)
                }
            })
        })
    })
}

window.addEventListener('DOMContentLoaded', function () {
    // Initialize on page load
    initializeDropdownVariantPickers();

    // Initialize for quick view drawer when it opens
    document.addEventListener('theme:quick-add:open', function() {
        setTimeout(function() {
            initializeDropdownVariantPickers();
        }, 100);
    });

    // Handle dropdown toggle clicks
    document.addEventListener('click', function (e) {
        if (e.target.classList.contains('dropdown_toggle') || e.target.closest('.dropdown_toggle')) {
            const toggle = e.target.classList.contains('dropdown_toggle') ? e.target : e.target.closest('.dropdown_toggle');
            const picker = toggle.closest('.dropdown-variant__picker');
            
            if (picker) {
                if (picker.classList.contains('open')) {
                    picker.classList.remove('open')
                } else {
                    // Close all other dropdowns
                    document.querySelectorAll('.dropdown-variant__picker').forEach(p => {
                        p.classList.remove('open')
                    });
                    picker.classList.add('open')
                }
            }
        } else {
            // Close all dropdowns when clicking outside
            document.querySelectorAll('.dropdown-variant__picker').forEach(picker => {
                picker.classList.remove('open')
            })
        }
    })
})

function updateSplitColorLegendLabels(productSelector) {
    const standardWrapper = productSelector.querySelector('.selector-wrapper--standard-colors');
    const limitedWrapper = productSelector.querySelector('.selector-wrapper--limited-edition-colors');

    if (!standardWrapper && !limitedWrapper) {
        return null;
    }

    const checkedLimited = limitedWrapper?.querySelector('input[type="radio"][limited]:checked');
    const checkedStandard = standardWrapper?.querySelector('input[type="radio"]:checked:not([limited])')
        || standardWrapper?.querySelector('input[type="radio"]:checked');
    const standardValueEl = standardWrapper?.querySelector('[data-color-group-value="standard"]');
    const limitedOptionNameEl = limitedWrapper?.querySelector('[data-limited-option-name]');

    if (standardValueEl) {
        standardValueEl.textContent = checkedStandard && !checkedStandard.hasAttribute('limited')
            ? checkedStandard.value
            : '';
    }

    if (limitedOptionNameEl) {
        limitedOptionNameEl.textContent = 'Limited Edition';
    }

    return {
        isLimitedColor: !!checkedLimited,
        selectedColorValue: checkedLimited?.value || checkedStandard?.value || null,
    };
}

function syncColorGroupSelection(productSelector) {
    const standardWrapper = productSelector.querySelector('.selector-wrapper--standard-colors');
    const limitedWrapper = productSelector.querySelector('.selector-wrapper--limited-edition-colors');

    if (!standardWrapper || !limitedWrapper) return;

    const checkedLimited = limitedWrapper.querySelector('input[type="radio"][limited]:checked');
    const checkedStandard = standardWrapper.querySelector('input[type="radio"]:checked');

    if (checkedLimited && checkedStandard) {
        checkedStandard.checked = false;
    }
}

// Initialize limited edition color UI (split groups + image badge)
function limitedEditionColor(container) {
    const targetContainer = container || document;
    const productSelectors = targetContainer.querySelectorAll('.product__selectors');

    productSelectors.forEach((productSelector) => {
        syncColorGroupSelection(productSelector);

        const colorState = updateSplitColorLegendLabels(productSelector);
        let isLimitedColor = colorState?.isLimitedColor || false;
        let selectedColorValue = colorState?.selectedColorValue || null;

        if (!colorState) {
            const colorWrapper = productSelector.querySelector(
                '.selector-wrapper--color:not(.selector-wrapper--standard-colors):not(.selector-wrapper--limited-edition-colors)'
            ) || productSelector.querySelector('.selector-wrapper--color');
            const checkedColorInput = colorWrapper?.querySelector('input[type="radio"]:checked');
            const hiddenColorInput = colorWrapper?.querySelector('[data-popout-input]');
            const fallbackValue = checkedColorInput?.value || hiddenColorInput?.value || null;

            if (fallbackValue) {
                isLimitedColor = checkedColorInput?.hasAttribute('limited')
                    || !!colorWrapper?.querySelector(`input[limited][value="${fallbackValue}"]`);
                selectedColorValue = fallbackValue;
            }
        }

        const productContainer = productSelector.closest('[data-section-id]')
            || productSelector.closest('[data-quick-add-modal]')
            || productSelector.closest('.product');
        const imageBadge = productContainer?.querySelector('.product_color_limited_badge[data-limited-edition-color]');

        if (imageBadge) {
            if (isLimitedColor && selectedColorValue) {
                const labelText = imageBadge.querySelector('[data-limited-edition-label-text]');

                if (labelText) {
                    labelText.textContent = 'Limited Edition';
                } else {
                    imageBadge.textContent = 'Limited Edition';
                }

                imageBadge.style.display = 'block';
            } else {
                imageBadge.style.display = 'none';
            }
        }
    });
}

// Initialize limited edition color event listeners
function initLimitedEditionColorListeners(container) {
    const targetContainer = container || document;
    
    targetContainer.querySelectorAll('tooltip-component').forEach(tooltipComponent => {
        // Skip if already initialized
        if (tooltipComponent.hasAttribute('data-limited-initialized')) return;
        tooltipComponent.setAttribute('data-limited-initialized', 'true');
        
        tooltipComponent.addEventListener('click', function () {
            const productContainer = this.closest('[data-section-id]') || this.closest('[data-quick-add-modal]');
            const productSelector = this.closest('.product__selectors');

            if (productSelector) {
                updateSplitColorLegendLabels(productSelector);
            }

            limitedEditionColor(productContainer);
        })
    });

    // Also listen for variant changes via radio button changes
    targetContainer.querySelectorAll('.product__selectors input[type="radio"]').forEach(input => {
        if (input.hasAttribute('data-limited-listener')) return;
        input.setAttribute('data-limited-listener', 'true');
        
        input.addEventListener('change', function() {
            const productContainer = this.closest('[data-section-id]') || this.closest('[data-quick-add-modal]');
            const productSelector = this.closest('.product__selectors');

            if (productSelector) {
                syncColorGroupSelection(productSelector);
            }

            limitedEditionColor(productContainer);
        });
    });
}

// Accordion metafield: switch content when variant changes
(function() {
    function updateAccordionMetafieldVisibility(variantId) {
        if (!variantId) return;
        document.querySelectorAll('[data-accordion-metafield]').forEach(function(container) {
            const contents = container.querySelectorAll('.accordion-metafield-variant-content');
            contents.forEach(function(el) {
                if (Number(el.getAttribute('data-variant-id')) === Number(variantId)) {
                    el.removeAttribute('hidden');
                } else {
                    el.setAttribute('hidden', '');
                }
            });
        });
    }

    document.addEventListener('theme:variant:change', function(e) {
        if (e.detail && e.detail.variant && e.detail.variant.id) {
            updateAccordionMetafieldVisibility(e.detail.variant.id);
        }
    });

    // Sync on load from variant input (e.g. ?variant= in URL)
    function initAccordionMetafieldFromInput() {
        var variantInput = document.querySelector('input[name="id"]');
        if (variantInput && variantInput.value) {
            updateAccordionMetafieldVisibility(variantInput.value);
        }
    }
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAccordionMetafieldFromInput);
    } else {
        initAccordionMetafieldFromInput();
    }
})();

document.addEventListener('theme:variant:change', function(e) {
    const productContainer = e.target;
    if (!productContainer) return;

    productContainer.querySelectorAll('.product__selectors').forEach((productSelector) => {
        updateSplitColorLegendLabels(productSelector);
    });

    limitedEditionColor(productContainer);
});

window.addEventListener('DOMContentLoaded', function () {
    // Initialize on page load
    limitedEditionColor();
    initLimitedEditionColorListeners();

    // Initialize for quick view drawer when it opens
    document.addEventListener('theme:quick-add:open', function() {
        setTimeout(function() {
            limitedEditionColor();
            initLimitedEditionColorListeners();
        }, 100);
    });
})